import React from 'react';

const About = () => {
  const skills = [
    { icon: 'fab fa-java', name: 'Java' },
    { icon: 'fab fa-python', name: 'Python' },
    { icon: 'fab fa-js', name: 'JavaScript' },
    { icon: 'fas fa-database', name: 'MongoDB' },
    { icon: 'fab fa-react', name: 'React' },
    { icon: 'fab fa-node-js', name: 'Node.js' },
    { icon: 'fas fa-seedling', name: 'Spring Boot' },
    { icon: 'fas fa-paper-plane', name: 'Postman' },
    { icon: 'fas fa-flask', name: 'JUnit' }
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <h3>Hello, I'm Sourav Dash Adhikari</h3>
            <p> Full Stack Developer by day, caffeine-powered debugger by night. I specialize in building smooth, scalable web and mobile apps using the MERN stack and Java Spring Boot — and yes, I do believe dark mode makes everything better.</p>
            <p>  I’m the kind of person who genuinely enjoys exploring new technologies — whether it’s spinning up Docker containers, trying out a new CSS framework at 1 AM, or figuring out how to make AI do some of the heavy lifting. In fact, I once took part in a no-code website-building competition where the only rule was: don’t write the code yourself. I didn’t — but I still made it work.</p>
            <p>Whether it’s crafting intuitive frontends, wrangling complex backends, or deploying with Docker and CI/CD, I enjoy turning ideas into real, usable tech. Clean code, creative UI, and a good playlist — that’s my development ritual.</p>
            <a 
              href="/assets/docs/RESUME.pdf" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn"
            >
              View Full Resume
            </a>
          </div>
          <div className="about-skills">
            <h3>My Skills</h3>
            <div className="skills-grid">
              {skills.map((skill, index) => (
                <div className="skill-item" key={index}>
                  <i className={skill.icon}></i>
                  <h4>{skill.name}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;